window.Toastr = require('toastr');

// Анимация прокрутки
//window.AOS = require('aos/dist/aos');

